import script from "./WatchLinkCell.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchLinkCell.vue?vue&type=script&setup=true&lang=js"

import "./WatchLinkCell.vue?vue&type=style&index=0&id=0120a570&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0120a570"]])

export default __exports__